import { useState } from "react";
import { timelineCase } from "@/mocks/gossip";

export default function Timeline() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="timeline" className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      {/* 区头 */}
      <div className="mb-6 flex flex-col justify-between gap-3 md:mb-8 md:flex-row md:items-end">
        <div>
          <div className="mb-2 flex items-center gap-2 text-[12px] font-semibold tracking-[0.25em] text-[rgb(224,124,45)]">
            <i className="ri-time-line h-4 w-4 flex items-center justify-center"></i>
            深度还原
          </div>
          <h2 className="font-display text-[24px] font-black leading-tight md:text-[30px]">
            来龙去脉 · 塌房前 72 小时
          </h2>
        </div>
        <p className="max-w-xl text-[13px] leading-relaxed text-[rgb(var(--ink-soft))]">
          从一条深夜热帖到全网定调，按时间还原来龙去脉，帮你三分钟看懂这一波事件怎么发酵。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* 左：案情卡 */}
        <div className="lg:sticky lg:top-32 lg:self-start">
          <div className="overflow-hidden rounded-lg border border-[rgb(var(--ink))]/10 bg-white">
            <div className="relative aspect-[16/10] w-full">
              <img
                src={timelineCase.steps[4]?.image}
                alt={timelineCase.title}
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-3 left-4 right-4">
                <span className="rounded-full bg-[rgb(224,124,45)] px-2.5 py-1 text-[11px] font-bold text-[rgb(var(--paper))]">
                  本期深挖 · 全网定调中
                </span>
                <h3 className="font-display mt-2 text-[18px] font-black leading-snug text-white md:text-[20px]">
                  {timelineCase.title}
                </h3>
              </div>
            </div>
            <div className="p-4">
              <p className="mb-4 text-[13px] leading-relaxed text-[rgb(var(--ink-soft))]">
                {timelineCase.intro}
              </p>
              <div className="grid grid-cols-3 gap-2">
                <div className="rounded-md bg-[rgb(var(--paper))] p-2.5 text-center">
                  <p className="font-display text-[18px] font-black text-[rgb(var(--brand))]">
                    {timelineCase.steps.length}
                  </p>
                  <p className="text-[11px] text-[rgb(var(--ink-soft))]">时间节点</p>
                </div>
                <div className="rounded-md bg-[rgb(var(--paper))] p-2.5 text-center">
                  <p className="font-display text-[18px] font-black text-[rgb(var(--brand))]">12.6w</p>
                  <p className="text-[11px] text-[rgb(var(--ink-soft))]">围观人次</p>
                </div>
                <div className="rounded-md bg-[rgb(var(--paper))] p-2.5 text-center">
                  <p className="font-display text-[18px] font-black text-[rgb(var(--brand))]">2</p>
                  <p className="text-[11px] text-[rgb(var(--ink-soft))]">疑似实锤</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 右：时间线 */}
        <div className="lg:col-span-2">
          <div className="relative ml-3 border-l-2 border-[rgb(var(--ink))]/12 pl-6 md:ml-5 md:pl-8">
            {timelineCase.steps.map((s, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="relative pb-4">
                  <span
                    className={`absolute -left-[34px] top-2 flex h-4 w-4 items-center justify-center rounded-full border-2 md:-left-[43px] ${
                      s.hot
                        ? "border-[rgb(224,124,45)] bg-[rgb(224,124,45)]"
                        : "border-[rgb(var(--ink))]/25 bg-[rgb(var(--paper))]"
                    }`}
                  >
                    {s.hot && (
                      <span className="h-1.5 w-1.5 rounded-full bg-[rgb(var(--paper))]"></span>
                    )}
                  </span>

                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className={`w-full rounded-lg border p-3 text-left transition-colors md:p-4 ${
                      isOpen
                        ? "border-[rgb(224,124,45)]/40 bg-white"
                        : "border-[rgb(var(--ink))]/10 bg-white hover:border-[rgb(var(--ink))]/25"
                    }`}
                  >
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="whitespace-nowrap rounded-md bg-[rgb(var(--ink))] px-2 py-0.5 text-[11px] font-semibold text-[rgb(var(--paper))]">
                        {s.time}
                      </span>
                      {s.hot && (
                        <span className="flex items-center gap-1 whitespace-nowrap text-[11px] font-semibold text-[rgb(224,124,45)]">
                          <i className="ri-fire-fill h-3 w-3 flex items-center justify-center"></i>
                          关键节点
                        </span>
                      )}
                      <span className="font-display flex-1 text-[15px] font-bold md:text-[16px]">
                        {s.title}
                      </span>
                      <i
                        className={`${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        } h-4 w-4 flex items-center justify-center text-[rgb(var(--ink-soft))]`}
                      ></i>
                    </div>
                  </button>

                  <div
                    className={`grid grid-rows-[0fr] transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr]" : ""
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="mt-3 rounded-lg bg-[rgb(var(--paper-deep))]/50 p-4">
                        {s.image && (
                          <img
                            src={s.image}
                            alt={s.title}
                            className="mb-3 aspect-[16/8] w-full rounded-md object-cover"
                          />
                        )}
                        <p className="text-[13px] leading-relaxed text-[rgb(var(--ink))]/80">
                          {s.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-2 flex flex-col items-center justify-between gap-3 rounded-lg border border-dashed border-[rgb(var(--ink))]/20 bg-white p-4 sm:flex-row">
            <p className="flex items-center gap-2 text-[13px] text-[rgb(var(--ink-soft))]">
              <i className="ri-questionnaire-line h-4 w-4 flex items-center justify-center text-[rgb(224,124,45)]"></i>
              后续进展仍在更新，蹲一个当事人回应。
            </p>
            <a
              href="#comments"
              className="flex items-center gap-1 whitespace-nowrap rounded-md bg-[rgb(var(--ink))] px-3.5 py-2 text-[13px] font-medium text-[rgb(var(--paper))] transition-colors hover:bg-[rgb(var(--brand))]"
            >
              去围观区讨论
              <i className="ri-arrow-right-line h-4 w-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}